<template>
  <div class="app checkout-container" :class="{ nochildren: (Object.keys(childrenCompany).length === 0) }">
    <div class="header-fixed">
      <div
        id="cache-menu"
        class="cache"
        @click="closeMobileMenu"
      />
      <Sidebar v-if="name === 'co.v2.template' || name === 'co.v2.chooseteam'" :name="name"/>
      <AppHeader :checkout="true"/>
      <main class="main">
        <div class="app-body">
          <router-view :key="$route.fullPath"/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import Sidebar from '../components/Sidebar';
import AppHeader from '../components/AppHeader';

export default {
  components: {
    AppHeader,
    Sidebar,
  },
  computed: {
    ...mapStores(useAccountStore),
    name() {
      return this.$route.name;
    },
    childrenCompany() {
      if (this.accountStore.company) {
        return this.accountStore.company.children;
      }
      return false;
    },
  },
  methods: {
    closeMobileMenu() {
      const menuExist = document.body.classList.contains('sidebar-mobile-show');
      if (menuExist) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    },
  },
};
</script>
